import React from 'react'
import { DrawerWithState } from 'src/components/DrawerWithState'
import { DrawerWithStateProps } from 'src/components/DrawerWithState/types'
import {
  useAddNavigatorMutation,
  useDeleteNavigatorMutation,
  useEditNavigatorMutation,
  useLazyGetNavigatorQuery,
} from 'src/store/APIs/navigators'

import { AddNavigator } from '../AddNavigator'
import { strings } from '../strings'
import { ViewNavigator } from '../ViewNavigator'

interface NavigatorsDrawerProps extends Partial<DrawerWithStateProps> {
  open: boolean
  onCloseDrawer: () => void
  selectedId?: string
}

export const NavigatorsDrawer: React.FC<NavigatorsDrawerProps> = ({
  open,
  onCloseDrawer,
  selectedId,
}) => {
  const [triggerAddResourceMutation, { isLoading: isLoadingAdd }] =
    useAddNavigatorMutation()
  const [triggerEditResourceMutation, { isLoading: isLoadingEdit }] =
    useEditNavigatorMutation()
  const [triggerDeleteResourceMutation, { isLoading: isLoadingDelete }] =
    useDeleteNavigatorMutation()

  const isLoadingRightButton = isLoadingAdd || isLoadingEdit

  return (
    <DrawerWithState
      selectedId={selectedId}
      open={open}
      onClose={onCloseDrawer}
      resourceName={strings.resourceName}
      RenderAdd={AddNavigator}
      RenderView={ViewNavigator}
      useLazyGetResource={useLazyGetNavigatorQuery}
      onCloseDrawer={onCloseDrawer}
      triggerAddResourceMutation={triggerAddResourceMutation}
      isLoadingLeftButton={isLoadingDelete}
      deleteModalTitle={strings.deleteModalTitle}
      isLoadingRightButton={isLoadingRightButton}
      triggerEditResourceMutation={triggerEditResourceMutation}
      triggerDeleteResourceMutation={triggerDeleteResourceMutation}
    />
  )
}
